const parseAcceptTime = (time?: string) => {
  if (!time) return { hour: 23, minute: 59, second: 59 };

  const [h, m, s] = time.split(':').map(Number);
  const hour = h || 0;
  const minute = m || 0;
  const second = s || 0;

  // Interpret 00:00:00 as 23:59:59 (end of day)
  const isMidnight = hour === 0 && minute === 0 && second === 0;

  return isMidnight ? { hour: 23, minute: 59, second: 59 } : { hour, minute, second };
};

export default parseAcceptTime;
